var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1828,
    height: 415,
    viewBox: "0 0 1828 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 323.968C4 275.204 39.3703 244.634 102.079 239.81L181.39 233.921V228.032C181.39 192.111 159.964 177.652 126.736 177.652C88.1349 177.652 66.7087 193.727 66.7087 221.592H10.9549C10.9549 164.246 58.1383 126.744 129.945 126.744C201.224 126.744 245.176 165.323 245.176 238.745V399.533H187.83L183.006 360.415C171.754 387.754 135.834 406.499 94.5742 406.499C38.2933 406.499 4 373.81 4 323.968ZM181.94 292.356V278.412L126.736 282.686C85.9923 286.444 70.4669 299.838 70.4669 321.287C70.4669 345.406 86.5422 357.207 116.023 357.207C156.217 357.207 181.94 333.077 181.94 292.356Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.638 399.544V134.776H370.215L375.578 169.081C392.18 142.281 424.342 126.744 460.24 126.744C526.706 126.744 561 168.016 561 236.614V399.544H495.633V252.15C495.633 207.683 473.657 186.233 439.879 186.233C399.685 186.233 375.028 214.099 375.028 256.974V399.544H309.638Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.136 399.539V189.46H599.229V134.772H650.136V52.2524H715.526V134.772H766.983V189.46H715.526V399.539H650.136Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.542 42.0595C831.542 20.0834 849.222 2.93103 871.736 2.93103C893.162 2.93103 910.853 20.0834 910.853 42.0595C910.853 64.0357 893.162 81.7037 871.736 81.7037C849.222 81.7037 831.542 64.0357 831.542 42.0595Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.131 268.226C950.131 185.695 998.38 126.744 1078.24 126.744C1115.2 126.744 1147.9 142.281 1164.52 168.543V0.799866H1229.37V399.533H1169.34L1165.06 358.273C1148.98 388.819 1114.68 406.499 1074.48 406.499C997.83 406.499 950.131 350.218 950.131 268.226ZM1163.99 266.083C1163.99 218.384 1134.51 185.156 1088.95 185.156C1043.39 185.156 1015.53 218.911 1015.53 266.083C1015.53 313.232 1043.39 346.471 1088.95 346.471C1134.51 346.471 1163.99 313.782 1163.99 266.083Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.06 267.16C1282.06 184.091 1336.19 126.744 1413.9 126.744C1493.23 126.744 1543.61 179.794 1543.61 262.336V282.17L1344.22 282.697C1349.05 329.33 1373.7 352.911 1417.13 352.911C1453.04 352.911 1476.61 338.966 1484.11 313.794H1544.69C1533.43 371.678 1485.18 406.499 1416.05 406.499C1337.27 406.499 1282.06 349.164 1282.06 267.16ZM1345.84 240.91H1478.76C1478.76 204.451 1453.57 180.333 1414.44 180.333C1375.86 180.333 1352.28 201.243 1345.84 240.91Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.84 323.968C1581.84 275.204 1617.21 244.634 1679.91 239.81L1759.21 233.921V228.032C1759.21 192.111 1737.8 177.652 1704.57 177.652C1665.97 177.652 1644.53 193.727 1644.53 221.592H1588.78C1588.78 164.246 1635.96 126.744 1707.78 126.744C1779.06 126.744 1823.01 165.323 1823.01 238.745V399.533H1765.66L1760.84 360.415C1749.58 387.754 1713.67 406.499 1672.41 406.499C1616.13 406.499 1581.84 373.81 1581.84 323.968ZM1759.78 292.356V278.412L1704.57 282.686C1663.83 286.444 1648.29 299.838 1648.29 321.287C1648.29 345.406 1664.37 357.207 1693.85 357.207C1734.05 357.207 1759.78 333.077 1759.78 292.356Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_115",
    x: 0,
    y: 0.799866,
    width: 1827.01,
    height: 413.699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_115",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.261557aaebb9d0bd1451a7998ca97cc5.svg";
export { ForwardRef as ReactComponent };